<template>
  <v-content style="background-color: #F8F8F8;margin-bottom: 8rem">
    <!-- Tab Desktop size -->
    <v-layout v-if="$vuetify.breakpoint.smAndUp">
      <v-flex xs12>
        <v-card color="#F8F8F8" flat class="mt-6">
          <v-layout justify-space-between>
            <v-spacer />
            <v-flex
              xs2
              v-for="tab in tabs"
              :key="tab.id"
              :href="`#tab-${tab.id - 1}`"
              @click="$router.push(tab.link)"
              class="tab-menu"
            >
              <v-layout
                class="d-flex justify-center align-center"
                :class="$route.path === tab.link ? 'tab-active' : ''"
              >
                <v-flex shrink class="mr-3">
                  <v-icon
                    class="tab-icon"
                    style="font-size: 50px"
                    :color="$route.path === tab.link ? '#FD5246' : '#575757'"
                    >{{ tab.icon }}</v-icon
                  >
                </v-flex>
                <v-flex
                  class="tab-text"
                  shrink
                  :style="
                    $route.path === tab.link
                      ? { 'font-size': '20px', color: '#FD5246' }
                      : { 'font-size': '20px', color: '#575757' }
                  "
                >
                  {{ $t(tab.name) }}
                </v-flex>
              </v-layout>
            </v-flex>

            <v-spacer />
          </v-layout>

          <v-divider style="border-width: 1px; background: #f8f8f8" />
        </v-card>

        <!-- <v-card flat class="mt-6">
          <v-tabs
            color="#FD5246"
            background-color="#F8F8F8"
            v-model="active_tab"
            light
            centered
          >
            <v-tab
              v-for="tab in tabs"
              :key="tab.id"
              :href="`#tab-${tab.id - 1}`"
              @click="$router.push(tab.link)"
            >
              <v-layout class="">
                <v-flex class="mr-4 d-flex justify-center align-center">
                  <v-icon style="font-size: 50px">{{ tab.icon }}</v-icon>
                </v-flex>
                <v-flex
                  :style="
                    tab.name === 'portfolio_profile'
                      ? { 'font-size': '20px', color: '#575757' }
                      : { 'font-size': '20px', color: '#FD5246' }
                  "
                  class="d-flex justify-center align-center"
                >
                  {{ $t(tab.name) }}
                </v-flex>
              </v-layout>
            </v-tab>
          </v-tabs>
        </v-card> -->
      </v-flex>
    </v-layout>

    <!-- Tab Mobile size  -->
    <v-layout v-else>
      <v-flex xs12>
        <v-layout class="text-center">
          <v-flex
            class="main-menu-hover"
            @click="$router.push('/profile-portfolio')"
          >
            <v-icon large>menu_book</v-icon>
            <div>
              {{ $t("portfolio") }}
            </div>
          </v-flex>
          <v-flex class="main-menu-hover main-menu-active">
            <v-icon large color="#FD5246">account_circle</v-icon>
            <div>
              {{ $t("about") }}
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- image Cover Profile -->
    <v-layout>
      <v-flex style="position: relative">
        <v-layout class="mx-sm-n12">
          <v-flex style="background-color: #000;">
            <v-img
              style="opacity: 0.75"
              width="100%"
              :height="
                $vuetify.breakpoint.lgAndUp
                  ? '300'
                  : '' || $vuetify.breakpoint.mdAndUp
                  ? '180'
                  : '' || $vuetify.breakpoint.smAndUp
                  ? '150'
                  : '' || $vuetify.breakpoint.smAndDown
                  ? '120'
                  : ''
              "
              :src="
                profile.mem_info
                  ? profile.mem_info.cover_url
                    ? url +
                      imgPath +
                      'images_profile_cover/' +
                      profile.mem_info.cover_url
                    : require('../assets/cover.png')
                  : require('../assets/cover.png')
              "
            ></v-img>
          </v-flex>
        </v-layout>

        <!-- image Profile -->
        <v-layout
          style="position: absolute; bottom: -40px;right: calc(50% - 40px);background-attachment: fixed;"
        >
          <v-flex>
            <v-layout class="justify-center">
              <v-flex shrink>
                <v-img
                  :src="
                    profile.mem_info
                      ? checkImage(profile.mem_info, 'avatar')
                      : image_profile_facebook
                      ? image_profile_facebook
                      : require('../assets/user_profile.png')
                  "
                  height="80px"
                  width="80px"
                  style="border-radius: 100%"
                ></v-img>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout class="justify-center form-profile mt-12 pt-4 pb-12">
      <v-flex class="lg9 md10 sm10 xs11">
        <!-- Btn edit profile  -->
        <v-layout v-if="$vuetify.breakpoint.smAndUp">
          <v-flex class="xs9 text-end">
            <v-btn
              outlined
              color="#FD5246"
              @click="
                $router.push({
                  path: `/profile-about/edit/${profile.profile_id}`,
                })
              "
            >
              <span>{{ $t("profile-edit") }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-else>
          <v-flex class="text-center">
            <v-btn
              outlined
              color="#FD5246"
              @click="
                $router.push({
                  name: 'GetUpdateProfile',
                  params: { id: profile.profile_id },
                })
              "
            >
              <span>{{ $t("profile-edit") }}</span>
            </v-btn>
          </v-flex>
        </v-layout>

        <!-- Detail Desktop -->
        <v-layout v-if="$vuetify.breakpoint.mdAndUp">
          <v-flex>
            <!-- Name  -->
            <v-layout class="justify-space-between mt-12">
              <v-flex>
                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3">
                    <span>{{ $t("profile-fname") }}</span>
                  </v-flex>
                  <v-flex class="xs5" style="color:#828282;">
                    {{ profile.name_th }}
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>
                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3">
                    <span>{{ $t("profile-lname") }}</span>
                  </v-flex>

                  <v-flex class="xs5" style="color:#828282;">
                    {{ profile.last_th }}
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs8">
                    <v-divider class="my-6"></v-divider>
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- Bio -->
            <v-layout class="justify-space-between">
              <v-flex>
                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3">
                    <span>{{ $t("bio") }}</span>
                  </v-flex>

                  <v-flex class="xs5" style="color:#828282;">
                    {{
                      profile.mem_info && profile.mem_info.bio
                        ? profile.mem_info.bio
                        : "-"
                    }}
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout class="mb-2">
              <v-spacer></v-spacer>
              <v-flex class="xs8">
                <v-divider class="my-6"></v-divider>
              </v-flex>
              <v-spacer></v-spacer>
            </v-layout>

            <!-- Location, Brand, Job -->
            <v-layout class="justify-space-between">
              <v-flex>
                <!-- Location -->
                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3">
                    <span>{{ $t("place") }}</span>
                  </v-flex>

                  <v-flex class="xs5" style="color:#828282;">
                    {{
                      profile.mem_info && profile.mem_info.location
                        ? profile.mem_info.location
                        : "-"
                    }}
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <!-- Brand -->
                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3">
                    <span>{{ $t("brand-name") }}</span>
                  </v-flex>

                  <v-flex class="xs5" style="color:#828282;">
                    {{
                      profile.mem_info && profile.mem_info.brand_name
                        ? profile.mem_info.brand_name
                        : "-"
                    }}
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <!-- Job -->
                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3">
                    <span>{{ $t("job") }}</span>
                  </v-flex>

                  <v-flex class="xs5" style="color:#828282;">
                    {{
                      profile.mem_info && profile.mem_info.profession
                        ? profile.mem_info.profession
                        : "-"
                    }}
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <!-- Design Type -->
                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3">
                    <span>{{ $t("design-type") }}</span>
                  </v-flex>

                  <v-flex class="xs5" style="color:#828282;">
                    {{
                      profile.mem_info && profile.mem_info.design_type
                        ? profile.mem_info.design_type
                        : "-"
                    }}
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs8">
                    <v-divider class="my-6"></v-divider>
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- Contact -->
            <v-layout class="justify-space-between">
              <v-flex>
                <!-- Email -->
                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3">
                    <span>{{ $t("profile-email") }}</span>
                  </v-flex>

                  <v-flex class="xs5" style="color:#828282;">
                    {{ profile.email }}
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <!-- Mobile Phone -->
                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3">
                    <span>{{ $t("profile-phonenumber") }}</span>
                  </v-flex>

                  <v-flex class="xs5" style="color:#828282;">
                    {{ profile.mobile_number }}
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <!-- Website -->
                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3">
                    <span>{{ $t("website") }}</span>
                  </v-flex>
                  <v-flex
                    class="xs5"
                    style="color:#828282;"
                    @click="openWebsite(profile)"
                  >
                    <span class="hover-social" v-show="profile.mem_info">
                      {{
                        profile.mem_info.website
                          ? profile.mem_info.website
                          : "-"
                      }}
                    </span>
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs8">
                    <v-divider class="my-6"></v-divider>
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- Social -->
            <v-layout>
              <v-flex>
                <!-- Facebook -->
                <v-layout class="mb-8">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3">
                    <v-icon style="font-size: 45px;color: #4481FB"
                      >facebook</v-icon
                    >
                  </v-flex>
                  <v-flex
                    v-if="profile.mem_info && profile.mem_info.facebook"
                    class="xs5 d-flex align-center"
                    style="color:#828282;"
                    @click="
                      openLink(
                        'https://www.facebook.com/',
                        profile.mem_info.facebook
                      )
                    "
                  >
                    <span class=" hover-social">
                      https://www.facebook.com/{{
                        profile.mem_info.facebook
                      }}</span
                    >
                  </v-flex>
                  <v-flex class="xs5" v-else>-</v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <!-- Instagram -->
                <v-layout class="mb-8">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3">
                    <v-img
                      width="35"
                      :src="require('../assets/icon-ig.png')"
                    ></v-img>
                  </v-flex>
                  <v-flex
                    v-if="profile.mem_info && profile.mem_info.instagram"
                    class="xs5 d-flex align-center"
                    style="color:#828282;"
                    @click="
                      openLink(
                        'https://www.instragram.com/',
                        profile.mem_info.instagram
                      )
                    "
                  >
                    <span class=" hover-social">
                      https://www.Instragram.com/{{
                        profile.mem_info ? profile.mem_info.instagram : ""
                      }}</span
                    >
                  </v-flex>
                  <v-flex class="xs5" v-else>-</v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <!-- Twitter -->
                <v-layout class="mb-8">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3">
                    <v-img
                      width="35"
                      :src="require('../assets/icon-tw.png')"
                    ></v-img>
                  </v-flex>
                  <v-flex
                    v-if="profile.mem_info && profile.mem_info.twitter"
                    class="xs5 d-flex align-center"
                    style="color:#828282;"
                    @click="
                      openLink(
                        'https://www.twitter.com/',
                        profile.mem_info.twitter
                      )
                    "
                  >
                    <span class=" hover-social">
                      https://www.twitter.com/{{
                        profile.mem_info ? profile.mem_info.twitter : ""
                      }}</span
                    >
                  </v-flex>
                  <v-flex class="xs5" v-else>-</v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <!-- Pinterest -->
                <v-layout class="mb-8">
                  <v-spacer></v-spacer>
                  <v-flex class="xs3 ml-n2">
                    <v-img
                      width="50"
                      :src="require('../assets/icon-pt.png')"
                    ></v-img>
                  </v-flex>
                  <v-flex
                    v-if="profile.mem_info && profile.mem_info.pinterest"
                    class="xs5 d-flex align-center"
                    style="color:#828282;"
                    @click="
                      openLink(
                        'https://www.pinterest.com/',
                        profile.mem_info.pinterest
                      )
                    "
                  >
                    <span class=" hover-social">
                      https://www.pinterest.com/{{
                        profile.mem_info ? profile.mem_info.pinterest : ""
                      }}</span
                    >
                  </v-flex>
                  <v-flex xs5 v-else>-</v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <v-layout class="mb-2">
                  <v-spacer></v-spacer>
                  <v-flex class="xs8">
                    <v-divider class="my-6"></v-divider>
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- Education -->
            <v-layout class="mb-4">
              <v-spacer></v-spacer>
              <v-flex class="xs3">
                <span class="font-weight-bold">
                  {{ $t("profile-study-information") }}
                </span>
              </v-flex>
              <v-flex class="xs5"></v-flex>
              <v-spacer></v-spacer>
            </v-layout>
            <div
              v-for="education in profile.educations"
              :key="education.education_id"
            >
              <v-layout class="my-3 justify-space-between">
                <v-flex>
                  <v-layout class="mb-2">
                    <v-spacer></v-spacer>
                    <v-flex class="xs3">
                      <span>{{ $t("profile-School-university") }}</span>
                    </v-flex>
                    <v-flex class="xs5" style="color:#828282;">
                      {{ education ? education.school_university : "-" }}
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>
                  <v-layout class="mb-2">
                    <v-spacer></v-spacer>
                    <v-flex class="xs3">
                      <span>{{ $t("profile-education-level") }}</span>
                    </v-flex>
                    <v-flex class="xs5" style="color:#828282;">
                      {{ education ? education.degree_id : "-" }}
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>
                  <v-layout class="mb-2">
                    <v-spacer></v-spacer>
                    <v-flex class="xs3">
                      <span>{{ $t("profile-branch") }}</span>
                    </v-flex>
                    <v-flex class="xs5" style="color:#828282;">
                      {{ education ? education.class_of : "-" }}
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>

            <v-layout class="mb-2">
              <v-spacer></v-spacer>
              <v-flex class="xs8">
                <v-divider class="my-6"></v-divider>
              </v-flex>
              <v-spacer></v-spacer>
            </v-layout>

            <!-- Work Experience -->
            <v-layout class="mb-4">
              <v-spacer></v-spacer>
              <v-flex class="xs3">
                <span class="font-weight-bold">{{
                  $t("profile-work-experience")
                }}</span>
              </v-flex>
              <v-flex class="xs5"></v-flex>
              <v-spacer></v-spacer>
            </v-layout>
            <div v-for="(work, work_index) in profile.works" :key="work_index">
              <v-layout class="justify-space-between mb-3">
                <v-flex>
                  <v-layout class="mb-2">
                    <v-spacer></v-spacer>
                    <v-flex class="xs3">
                      <span>{{ $t("profile-company") }}</span>
                    </v-flex>
                    <v-flex class="xs5" style="color:#828282;">
                      {{ work ? work.company : "-" }}
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>
                  <v-layout class="mb-2">
                    <v-spacer></v-spacer>
                    <v-flex class="xs3">
                      <span>{{ $t("profile-position") }}</span>
                    </v-flex>
                    <v-flex class="xs5" style="color:#828282;">
                      {{ work ? work.position : "-" }}
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>

        <v-layout v-else>
          <v-flex>
            <!-- Name  -->
            <v-layout class="justify-space-between mt-12">
              <v-flex>
                <v-layout class="mb-2">
                  <v-flex class="xs5">
                    <span>{{ $t("profile-fname") }}</span>
                  </v-flex>
                  <v-flex class="xs7" style="color:#828282;">
                    {{ profile.name_th }}
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>
                <v-layout class="mb-2">
                  <v-flex class="xs5">
                    <span>{{ $t("profile-lname") }}</span>
                  </v-flex>

                  <v-flex class="xs7" style="color:#828282;">
                    {{ profile.last_th }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-divider class="my-6"></v-divider>

            <!-- bio -->
            <v-layout class="justify-space-between">
              <v-flex>
                <v-layout class="mb-2">
                  <v-flex class="xs5">
                    <span>{{ $t("bio") }}</span>
                  </v-flex>

                  <v-flex class="xs7" style="color:#828282;">
                    {{
                      profile.mem_info && profile.mem_info.bio
                        ? profile.mem_info.bio
                        : "-"
                    }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-divider class="my-6"></v-divider>

            <!-- Locaion, brand, job -->
            <v-layout class="justify-space-between">
              <v-flex>
                <v-layout class="mb-2">
                  <v-flex class="xs5">
                    <span>{{ $t("place") }}</span>
                  </v-flex>

                  <v-flex class="xs7" style="color:#828282;">
                    {{
                      profile.mem_info && profile.mem_info.location
                        ? profile.mem_info.location
                        : "-"
                    }}
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>
                <v-layout class="mb-2">
                  <v-flex class="xs5">
                    <span>{{ $t("brand-name") }}</span>
                  </v-flex>

                  <v-flex class="xs7" style="color:#828282;">
                    {{
                      profile.mem_info && profile.mem_info.brand_name
                        ? profile.mem_info.brand_name
                        : "-"
                    }}
                  </v-flex>
                </v-layout>
                <v-layout class="mb-2">
                  <v-flex class="xs5">
                    <span>{{ $t("job") }}</span>
                  </v-flex>

                  <v-flex class="xs7" style="color:#828282;">
                    {{
                      profile.mem_info && profile.mem_info.profession
                        ? profile.mem_info.profession
                        : "-"
                    }}
                  </v-flex>
                </v-layout>
                <v-layout class="mb-2">
                  <v-flex class="xs5">
                    <span>{{ $t("design-type") }}</span>
                  </v-flex>

                  <v-flex class="xs7" style="color:#828282;">
                    {{
                      profile.mem_info && profile.mem_info.design_type
                        ? profile.mem_info.design_type
                        : "-"
                    }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-divider class="my-6"></v-divider>

            <!-- Contact -->
            <v-layout class="justify-space-between">
              <v-flex>
                <v-layout class="mb-2">
                  <v-flex class="xs5">
                    <span>{{ $t("profile-email") }}</span>
                  </v-flex>

                  <v-flex class="xs7" style="color:#828282;">
                    {{ profile.email }}
                  </v-flex>
                </v-layout>
                <v-layout class="mb-2">
                  <v-flex class="xs5">
                    <span>{{ $t("profile-phonenumber") }}</span>
                  </v-flex>

                  <v-flex class="xs7" style="color:#828282;">
                    {{ profile.mobile_number }}
                  </v-flex>
                </v-layout>
                <v-layout class="mb-2">
                  <v-flex class="xs5">
                    <span>{{ $t("website") }}</span>
                  </v-flex>

                  <v-flex
                    class="xs7"
                    style="color:#828282;"
                    @click="openWebsite(profile)"
                  >
                    <span class="hover-social" v-show="profile.mem_info">
                      {{
                        profile.mem_info.website
                          ? profile.mem_info.website
                          : "-"
                      }}
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-divider class="my-6"></v-divider>

            <!-- Social -->
            <v-layout>
              <v-flex>
                <v-layout class="mb-8">
                  <v-flex class="xs5">
                    <v-icon style="font-size: 45px;color: #4481FB"
                      >facebook</v-icon
                    >
                  </v-flex>
                  <v-flex
                    v-if="profile.mem_info && profile.mem_info.facebook"
                    class="xs7 d-flex align-center"
                    style="color:#828282;"
                    @click="
                      openLink(
                        'https://www.facebook.com/',
                        profile.mem_info.facebook
                      )
                    "
                  >
                    <span class=" hover-social">
                      <!-- https://www.facebook.com/ -->
                      {{ profile.mem_info.facebook }}
                    </span>
                  </v-flex>
                  <v-flex xs8 v-else>-</v-flex>
                </v-layout>

                <v-layout class="mb-8">
                  <v-flex class="xs5">
                    <v-img
                      width="35"
                      :src="require('../assets/icon-ig.png')"
                    ></v-img>
                  </v-flex>
                  <v-flex
                    v-if="profile.mem_info && profile.mem_info.instagram"
                    class="xs7 d-flex align-center"
                    style="color:#828282;"
                    @click="
                      openLink(
                        'https://www.instragram.com/',
                        profile.mem_info.instagram
                      )
                    "
                  >
                    <span class=" hover-social">
                      <!-- https://www.Instragram.com/ -->
                      {{ profile.mem_info ? profile.mem_info.instagram : "" }}
                    </span>
                  </v-flex>
                  <v-flex v-else>-</v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <v-layout class="mb-8">
                  <v-flex class="xs5">
                    <v-img
                      width="35"
                      :src="require('../assets/icon-tw.png')"
                    ></v-img>
                  </v-flex>
                  <v-flex
                    v-if="profile.mem_info && profile.mem_info.twitter"
                    class="xs7 d-flex align-center"
                    style="color:#828282;"
                    @click="
                      openLink(
                        'https://www.twitter.com/',
                        profile.mem_info.twitter
                      )
                    "
                  >
                    <span class=" hover-social">
                      <!-- https://www.twitter.com/ -->

                      {{ profile.mem_info ? profile.mem_info.twitter : "" }}
                    </span>
                  </v-flex>
                  <v-flex v-else>-</v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <v-layout class="mb-8">
                  <v-flex class="xs5">
                    <v-img
                      width="50"
                      :src="require('../assets/icon-pt.png')"
                    ></v-img>
                  </v-flex>
                  <v-flex
                    v-if="profile.mem_info && profile.mem_info.pinterest"
                    class="xs7 d-flex align-center"
                    style="color:#828282;"
                    @click="
                      openLink(
                        'https://www.pinterest.com/',
                        profile.mem_info.pinterest
                      )
                    "
                  >
                    <span class=" hover-social">
                      <!-- https://www.pinterest.com/ -->
                      {{ profile.mem_info ? profile.mem_info.pinterest : "" }}
                    </span>
                  </v-flex>
                  <v-flex v-else>-</v-flex>
                  <v-spacer></v-spacer>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-divider class="my-6"></v-divider>

            <!-- Education -->
            <v-layout class="mb-4">
              <v-flex class="xs12">
                <span class="font-weight-bold">{{
                  $t("profile-study-information")
                }}</span>
              </v-flex>
            </v-layout>
            <div
              v-for="education in profile.educations"
              :key="education.education_id"
            >
              <v-layout class="my-3 justify-space-between">
                <v-flex>
                  <v-layout class="mb-2">
                    <v-flex class="xs5">
                      <span>{{ $t("profile-School-university") }}</span>
                    </v-flex>

                    <v-flex class="xs7" style="color:#828282;">
                      {{ education ? education.school_university : "-" }}
                    </v-flex>
                  </v-layout>
                  <v-layout class="mb-2">
                    <v-flex class="xs5">
                      <span>{{ $t("profile-education-level") }}</span>
                    </v-flex>

                    <v-flex class="xs7" style="color:#828282;">
                      {{ education ? education.degree_id : "-" }}
                    </v-flex>
                  </v-layout>
                  <v-layout class="mb-2">
                    <v-flex class="xs5">
                      <span>{{ $t("profile-branch") }}</span>
                    </v-flex>

                    <v-flex class="xs7" style="color:#828282;">
                      {{ education ? education.class_of : "-" }}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>

            <v-divider class="my-6"></v-divider>

            <!-- Work -->
            <v-layout class="mb-4">
              <v-flex class="xs12">
                <span class="font-weight-bold">
                  {{ $t("profile-work-experience") }}
                </span>
              </v-flex>
            </v-layout>
            <div v-for="(work, work_index) in profile.works" :key="work_index">
              <v-layout class="justify-space-between mb-3">
                <v-flex>
                  <v-layout class="mb-2">
                    <v-flex class="xs5">
                      <span>{{ $t("profile-company") }}</span>
                    </v-flex>

                    <v-flex class="xs7" style="color:#828282;">
                      {{ work ? work.company : "-" }}
                    </v-flex>
                  </v-layout>
                  <v-layout class="mb-2">
                    <v-flex class="xs5">
                      <span>{{ $t("profile-position") }}</span>
                    </v-flex>

                    <v-flex class="xs7" style="color:#828282;">
                      {{ work ? work.position : "-" }}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import { mapState } from "vuex";
import { domain, imgPath } from "../services/Constants";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "ProfileAbout",
  components: {
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    imgPath: imgPath,
    url: domain,
    active_tab: "tab-1",
    tabs: [
      {
        id: 1,
        name: "portfolio_profile",
        icon: "menu_book",
        link: "/profile-portfolio",
      },
      {
        id: 2,
        name: "about",
        icon: "account_circle",
        link: "/profile-about",
      },
      // {
      //     id: 3,
      //     name: 'award',
      //     icon: 'emoji_events',
      // }
    ],
    tab: 2,
    isActiveMainMenu: false,
  }),
  computed: {
    ...mapState({
      profile: (state) => {
        return state.profile.personalInfo;
      },
      image_profile_facebook: (state) => {
        return state.auth.image_profile_facebook;
      },
    }),
  },
  methods: {
    openWebsite(val) {
      if (val.mem_info && val.mem_info.website) {
        window.open(val.mem_info.website);
      }
    },
    openLink(text, link) {
      window.open(text + link, "_blank");
    },
    checkImage(val, type) {
      if (val) {
        switch (type) {
          case "avatar":
            if (val.avatar) {
              return this.url + this.imgPath + "images_profile/" + val.avatar;
            } else {
              if (this.image_profile_facebook) {
                return this.image_profile_facebook;
              } else {
                return require("../assets/user_profile.png");
              }
            }
            break;

          case "cover_url":
            return val.cover_url
              ? this.url +
                  this.imgPath +
                  "images_profile_cover/" +
                  val.cover_url
              : require("../assets/cover.png");
            break;
        }
      } else {
        return require("../assets/user_profile.png");
      }
    },
  },
};
</script>

<style scoped>
.hover-social:hover {
  cursor: pointer;
  color: #f4511e;
}
.active-tab {
  color: #f4511e;
}
</style>
